import http from "../httpService";
import { apiUrl } from "../../../config.js";
import { DateTime } from "luxon";

const apiEndpoint = apiUrl + "/crm/sales-card/";

export function saveSalesCard(salesCard) {
  return http.post(apiEndpoint, salesCard);
}

export function getBoardSalesCards(
  dateFrom = DateTime.now().startOf("day"),
  dateTo = DateTime.now().endOf("day"),
  leadID = 0,
  customerID = 0,
  assignedUserID = 0
) {
  return http.get(
    apiEndpoint +
      `board-sales-cards/${dateFrom}/${dateTo}/${leadID}/${customerID}/${assignedUserID}`
  );
}

export function getSalesCards() {
  return http.get(apiEndpoint + "sales-cards");
}

export function getSalesCardDetail(salesCardID) {
  return http.get(apiEndpoint + "sales-card-detail/" + salesCardID);
}

export function updateSalesCardStatus(
  salesCard,
  statusID = 0,
  archive = false
) {
  if (statusID > 0) {
    //salesCard.ID = parseInt(salesCard.id);
    salesCard.statusID = statusID;
  } else if (archive) {
    salesCard.archive = archive;
  }
  return http.post(apiEndpoint + "sales-card-status", salesCard);
}

export function closeWonSalesOrder(customer, salesOrder, operationCard) {
  return http.post(apiEndpoint + "close-won-sales-card", {
    customer,
    salesOrder,
    operationCard,
  });
}

export function getSalesCardNotes(salesCardID) {
  return http.get(apiEndpoint + "sales-card-notes/" + salesCardID);
}

export function saveSalesCardNote(salesCardNote) {
  return http.post(apiEndpoint + "sales-card-note", salesCardNote);
}

export function deleteSalesCard(salesCardID = 0) {
  return http.delete(apiEndpoint + "sales-card/" + salesCardID);
}
